import { blue, green, grey, lightBlue, neutralGrey, neutralWhite, orange, red , aquanowGreen , aquanowSlate  } from '../../colors';

const palette = {
  primary: {
    main: "#4EC6A1",
    light: aquanowGreen[500],
    dark: "#4EC6A1",
    darker: "#4EC6A1",
    contrastText: aquanowGreen[250],
  },
  common: {
    black: neutralGrey[975],
    white: neutralGrey[25],
  },
  secondary: {
    main: neutralGrey[200],
    light: neutralGrey[100],
    dark: neutralGrey[250],
    darker: neutralGrey[300],
    contrastText: neutralGrey[975],
  },
  error: {
    main: red[700],
    light: red[400],
    dark: red[800],
    darker: red[900],
    contrastText: neutralGrey[25],
  },
  success: {
    main: green[700],
    light: green[400],
    dark: green[800],
    darker: green[900],
    contrastText: neutralGrey[25],
  },
  warning: {
    main: '#f9a43a',
    light: '#f87171',
    dark: '#e65100',
    darker: '#e65100',
    contrastText: neutralGrey[975],
  },
  info: {
    main: lightBlue[700],
    light: blue[400],
    dark: blue[800],
    darker: blue[900],
    contrastText: neutralGrey[25],
  },
  grey: {
    '50': '#9ca3af',
    '100': '#374151',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  navbar: {
    main: aquanowSlate[900],
    light: "#111827",
    dark: "#000000",
    contrastText: "#FFFFFF",
  },
  text: {
    primary: "#FAFAFA",
    secondary: neutralGrey[50],
    disabled: neutralGrey[300],
  },
  divider: "#334155",
  background: {
    paper: aquanowSlate[800],
    default: aquanowSlate[900],
  },
  action: {
    active: aquanowGreen[800],
    hover: 'rgba(0, 0, 0, 0.0400)',
    hoverOpacity: 0.04,
    selected: neutralGrey[200],
    selectedOpacity: 0.08,
    disabled: 'rgba(0, 0, 0, 0.2600)',
    disabledBackground: neutralGrey[150],
    disabledOpacity: 0.38,
    focusBorderInner: neutralGrey[25],
    focusBorderOuter: blue[600],
    focusOpacity: 0.16,
    activatedOpacity: 0.12,
  },
};

export default palette;
